//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { useAlert } from 'react-alert';
import { useDispatch } from 'react-redux';
import { Button, Form, Table, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlus,
  faMinus,
  faWarehouse,
} from '@fortawesome/free-solid-svg-icons';
import {
  changeCuttingPackageStatus,
  startCuttingWithMaterials,
} from 'services/apiRequests/cutting/update';
import { getStorageItems } from 'services/apiRequests/storage.api';
import { setSpinner } from 'services/store/actions/view';
import { cuttingPackageStatus } from 'services/utils/const';
import Modal from 'PageTemplates/ModalTemplate';

const ChangeEmployeeStatusModal = ({ cuttingPackage, closeModal }) => {
  const dispatch = useDispatch();
  const alert = useAlert();
  const [materials, setMaterials] = useState([]);
  const [availableItems, setAvailableItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const isStarting =
    cuttingPackage.status !== cuttingPackageStatus.IN_PROGRESS;

  useEffect(() => {
    if (isStarting) {
      fetchAvailableItems();
      // Inicjalizuj z jednym pustym materiałem
      setMaterials([{ storageItemId: '', quantity: 1 }]);
    }
  }, [isStarting]);

  const fetchAvailableItems = async () => {
    try {
      const response = await getStorageItems();
      if (response?.items) {
        setAvailableItems(response.items);
      }
    } catch (error) {
      console.error('Błąd pobierania elementów magazynowych:', error);
      alert.error('Błąd podczas pobierania elementów magazynowych');
    }
  };

  const addMaterialRow = () => {
    setMaterials([...materials, { storageItemId: '', quantity: 0 }]);
  };

  const removeMaterialRow = (index) => {
    if (materials.length > 1) {
      setMaterials(materials.filter((_, i) => i !== index));
    }
  };

  const updateMaterial = (index, field, value) => {
    const updated = [...materials];
    updated[index][field] = value;
    setMaterials(updated);
  };

  const getSelectedItem = (itemId) => {
    return availableItems.find((item) => item._id === itemId);
  };

  const handleSubmit = async () => {
    if (isStarting) {
      // Walidacja materiałów dla rozpoczęcia cięcia
      const validMaterials = materials.filter(
        (m) => m.storageItemId && m.quantity > 0,
      );

      // if (validMaterials.length === 0) {
      //   setError('Musisz dodać przynajmniej jeden materiał');
      //   return;
      // }

      // Sprawdź czy nie przekraczamy stanów magazynowych
      for (const material of validMaterials) {
        const item = getSelectedItem(material.storageItemId);
        if (item && material.quantity > item.quantity) {
          setError(
            `Nie ma wystarczającej ilości produktu "${item.name}". Dostępne: ${item.quantity}, wybrano: ${material.quantity}`,
          );
          return;
        }
      }
    }

    setLoading(true);
    setError('');

    try {
      dispatch(setSpinner(true));

      if (isStarting) {
        // Rozpoczęcie cięcia z materiałami
        const validMaterials = materials.filter(
          (m) => m.storageItemId && m.quantity > 0,
        );

        if (validMaterials.length > 0) {
          await startCuttingWithMaterials(
            cuttingPackage._id,
            validMaterials,
          );
          dispatch(setSpinner(false));
          alert.success('Cięcie rozpoczęte z materiałami');
          window.location.reload();
          closeModal();
        } else {
          await changeCuttingPackageStatus(
            cuttingPackage._id,
            cuttingPackageStatus.IN_PROGRESS,
            () => {
              dispatch(setSpinner(false));
              alert.success('Cięcie rozpoczęte');
              window.location.reload();
              closeModal();
            },
            () => {
              dispatch(setSpinner(false));
              alert.error('Błąd!');
            },
          );
        }
      } else {
        // Zakończenie cięcia (bez materiałów)
        await changeCuttingPackageStatus(
          cuttingPackage._id,
          cuttingPackageStatus.READY,
          () => {
            dispatch(setSpinner(false));
            alert.success('Cięcie zakończone');
            window.location.reload();
            closeModal();
          },
          () => {
            dispatch(setSpinner(false));
            alert.error('Błąd!');
          },
        );
      }
    } catch (error) {
      dispatch(setSpinner(false));
      alert.error('Błąd podczas zmiany statusu');
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };
  const isFormValid = true;
  // materials.some((m) => m.storageItemId && m.quantity > 0);

  return (
    <Modal
      title={isStarting ? 'Rozpocznij cięcie' : 'Zakończ cięcie'}
      closeModal={closeModal}
      onOk={handleSubmit}
      okButtonText={
        loading
          ? 'Zapisywanie...'
          : isStarting
          ? 'Rozpocznij cięcie'
          : 'Zakończ cięcie'
      }
      disabled={loading || !isFormValid}
      backdrop="static"
      size={isStarting ? 'lg' : 'md'}
    >
      {!isStarting ? (
        <p>Czy chcesz zakończyć cięcie?</p>
      ) : (
        <>
          <div className="mb-3">
            <h6 className="text-muted mb-1">Pakiet cięcia:</h6>
            <h5 className="mb-3">{cuttingPackage?.name}</h5>
          </div>

          {error && (
            <Alert variant="danger" className="mb-3">
              {error}
            </Alert>
          )}

          <div className="mb-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6>Materiały do pobrania z magazynu</h6>
              <Button
                variant="outline-primary"
                size="sm"
                onClick={addMaterialRow}
              >
                <FontAwesomeIcon icon={faPlus} className="me-1" />
                Dodaj materiał
              </Button>
            </div>

            <Table responsive>
              <thead>
                <tr>
                  <th>Materiał</th>
                  <th>Dostępne</th>
                  <th className="text-center">Pobierz</th>
                  <th className="text-center">Akcje</th>
                </tr>
              </thead>
              <tbody>
                {materials.map((material, index) => {
                  const selectedItem = getSelectedItem(
                    material.storageItemId,
                  );
                  return (
                    <tr key={index}>
                      <td>
                        <Form.Select
                          value={material.storageItemId}
                          onChange={(e) =>
                            updateMaterial(
                              index,
                              'storageItemId',
                              e.target.value,
                            )
                          }
                          size="sm"
                        >
                          <option value="">Wybierz materiał...</option>
                          {availableItems.map((item) => (
                            <option key={item._id} value={item._id}>
                              {item.name} ({item.type || 'Brak typu'})
                            </option>
                          ))}
                        </Form.Select>
                      </td>
                      <td>
                        {selectedItem ? (
                          <span
                            className={
                              selectedItem.quantity > 0
                                ? 'text-success'
                                : 'text-danger'
                            }
                          >
                            <FontAwesomeIcon
                              icon={faWarehouse}
                              className="me-1"
                            />
                            {selectedItem.quantity}{' '}
                            {selectedItem.unit || 'szt.'}
                          </span>
                        ) : (
                          <span className="text-muted">-</span>
                        )}
                      </td>
                      <td className="text-center">
                        <Form.Control
                          type="number"
                          value={material.quantity}
                          onChange={(e) =>
                            updateMaterial(
                              index,
                              'quantity',
                              parseFloat(e.target.value) || 0,
                            )
                          }
                          min="0"
                          max={selectedItem?.quantity || 0}
                          step="1"
                          size="sm"
                          style={{ width: '100px', margin: '0 auto' }}
                          className="text-center"
                        />
                      </td>
                      <td className="text-center">
                        {materials.length > 1 && (
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => removeMaterialRow(index)}
                          >
                            <FontAwesomeIcon icon={faMinus} />
                          </Button>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>

          <Alert variant="info">
            <small>
              Wybierz materiały które będziesz używać do cięcia. Stan
              magazynowy zostanie automatycznie zaktualizowany.
            </small>
          </Alert>
        </>
      )}
    </Modal>
  );
};

export default ChangeEmployeeStatusModal;
